

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/games/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.COCCXpMH.js","_app/immutable/chunks/disclose-version.BfHQzUcx.js","_app/immutable/chunks/index-client.HYok5wSr.js","_app/immutable/chunks/legacy.DG24rG7b.js","_app/immutable/chunks/index.D5ajVCgE.js"];
export const stylesheets = ["_app/immutable/assets/fa-layers-text.DdWHEj6G.css"];
export const fonts = [];
